<!--
 * @Description: file content
 * @Author: yangsibo
 * @Date: 2022-05-12 10:24:14
 * @LastEditors: yangsibo
 * @LastEditTime: 2023-01-11 17:11:30
 * @FilePath: /adm.xiangli360.com/src/views/Setting/RoleManagement/components/ConfigRole.vue
-->
<template>
  <el-dialog
    class="dialog-bg dialog-config-role-auth"
    title="角色权限配置"
    :visible.sync="dialogConfigRoleAuthVisible"
    :before-close="close"
    width="760px"
  >
    <ul class="list">
      <li class="item">
        <span class="left-side">角色名称：</span>
        <div class="right-side">{{ curRoleDetail.roleName }}</div>
        <div class="delete-side" @click="deleteSide">删除该角色</div>
      </li>
      <li class="item">
        <span class="left-side">选择权限：</span>
        <div class="auth left-auth">
          <el-tree
            :data="authData"
            show-checkbox
            default-expand-all
            :default-checked-keys="checkedAuthData"
            node-key="id"
            ref="tree"
            highlight-current
            :props="defaultProps"
            @check="handleCheckChange"
          >
          </el-tree>
        </div>
        <div class="select-auth" v-show="selectedAuth.length > 0">
          <div class="select-text">
            已选权限
            <div class="popper__arrow"></div>
          </div>
          <el-collapse v-model="activeNames">
            <el-collapse-item
              :disabled="true"
              :name="item.id"
              v-for="item in selectedAuth"
              :key="item.id"
            >
              <template slot="title">
                <i
                  v-show="false"
                  class="icon-btn"
                  :class="{
                    'el-icon-caret-bottom': activeNames.includes(item.id),
                    'el-icon-caret-right': !activeNames.includes(item.id),
                  }"
                ></i>
                {{ item.menuName }}
              </template>
              <div class="explain">说明</div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </li>
    </ul>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="handleSaveConfigRoleAuth"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "ConfigRole",
  data() {
    return {
      authData: [],
      checkedAuthData: [],
      defaultProps: {
        children: "children",
        label: "menuName",
      },
      selectedAuth: [],
      activeNames: [],
    };
  },
  props: {
    dialogConfigRoleAuthVisible: {
      type: Boolean,
      default: () => true,
    },
    curRoleDetail: {
      type: Object,
      default: () => {},
    },
    systemType: {
      type: Number,
      default: 2,
    },
  },
  components: {},
  computed: {},
  methods: {
    close(showType) {
      this.$emit("close", "dialogConfigRoleAuthVisible", showType);
    },
    handleCheckChange(data, checked, indeterminate) {
      let selectedAuth = this.$refs.tree.getCheckedNodes();
      this.selectedAuth = selectedAuth.filter((item) => {
        return item.menuType == 4;
      });
    },
    /**
     * @descripttion: 保存配置角色权限
     * @Author: juanjuanhui
     * @Date: 2022-02-25 09:36:39
     */
    async handleSaveConfigRoleAuth() {
      let tempAry = this.$refs.tree
        .getCheckedNodes()
        .concat(this.$refs.tree.getHalfCheckedNodes());
      let sRefRoleMenuButtonDtos = [];
      tempAry.forEach((item) => {
        let roleMenuButtonDtos = {};
        if (item.type == 2) {
          roleMenuButtonDtos.menuId = item.parentId;
          roleMenuButtonDtos.buttonId = item.id;
        } else {
          roleMenuButtonDtos.menuId = item.id;
        }
        sRefRoleMenuButtonDtos.push(roleMenuButtonDtos);
      });
      let params = {
        id: this.curRoleDetail.id,
        sRefRoleMenuButtonDtos,
      };
      try {
        let { status } = await this.$http.role.setMenuForRole({
          ...params,
          systemType: this.systemType,
        });
        if (status == 1) {
          this.$message({
            type: "success",
            message: "角色配置权限成功",
            duration: 2000,
          });
          this.close();
        }
      } catch (error) {}
    },
    /**
     * @description: 删除角色
     * @Author: yangsibo
     * @Date: 2022-05-24 11:26:32
     * @return {*}
     */
    deleteSide() {
      this.close("dialogRemoveRoleVisible");
    },
    /**
     * @description: 获取选择权限
     * @Author: yangsibo
     * @Date: 2022-05-25 09:32:54
     * @return {*}
     */
    async selectSMenuTree() {
      this.authData = [];
      try {
        let { data } = await this.$http.common.selectSMenuTree({
          roleIdList: [this.curRoleDetail.id],
          systemType: this.systemType,
        });
        if (data) {
          this.authData = data;
          this.checkedAuthData = [];
          this.setCheckedAuthData(data);
          setTimeout(() => {
            let selectedAuth = this.$refs.tree.getCheckedNodes();
            this.selectedAuth = selectedAuth.filter((item) => {
              return item.menuType == 4;
            });
          }, 0);
        }
      } catch (error) {}
    },
    /**
     * @description:设置选中权限数据
     * @Author: yangsibo
     * @Date: 2022-05-26 10:31:03
     * @param {*} data
     */
    setCheckedAuthData(data) {
      data.forEach((item) => {
        if (item.selectedFlag) {
          this.checkedAuthData.push(item.id);
        }
        if (item.children) {
          this.setCheckedAuthData(item.children);
        }
      });
    },
  },
  created() {},
  mounted() {
    this.selectSMenuTree();
  },
};
</script>
<style lang="scss" scoped>
@import "./select-auth.scss";
.dialog-config-role-auth {
  .el-dialog__body {
    padding: 10px 30px 20px;
    .list {
      .item {
        display: flex;
        line-height: 35px;
        color: #222222;
        font-size: 16px;
        &:nth-child(2) {
          margin-top: 10px;
        }
        .right-side {
          flex: 1;
        }
        .delete-side {
          width: 110px;
          height: 36px;
          background: #e9f6f6;
          border-radius: 3px;
          margin-left: 15px;
          font-size: 16px;
          color: #018388;
          text-align: center;
          line-height: 36px;
          cursor: pointer;
        }
        .auth {
          width: 310px;
          max-height: 300px;
          padding-top: 10px;
          margin-top: 5px;
          overflow-y: auto;
          background-color: #ffffff;
          border-radius: 2px;
          border: solid 1px #e5e6eb;
          display: flex;
          box-sizing: border-box;
          line-height: 0;
          &:first-child {
            margin-right: 20px;
          }
          .el-tree{
            width: 100%;
          }
        }
        .select-auth {
          margin: 5px 0 0 40px;
        }
      }
    }
  }
}
</style>

